import { selectors as brandSelectors } from "../brand";
import { actions as modalActions } from "../modals";

export const openFeedback = () => (dispatch, getState) => {
  const customURL = brandSelectors.getBrandValue(
    getState(),
    "Feedback.library_url"
  );
  if (customURL) {
    window.open(customURL, "_blank");
  } else {
    dispatch(modalActions.openModal("FeedbackModal"));
  }
};
